import React from "react";
import cn from "classnames";
import { Link } from "gatsby";
import Loadable from "@loadable/component";
import jixiao from "../../assets/images/common/more-products/jixiao.png";
import kaoqin from "../../assets/images/common/more-products/kaoqin.png";
import peixun from "../../assets/images/common/more-products/peixun.png";
import renshi from "../../assets/images/common/more-products/renshi.png";
import xinchou from "../../assets/images/common/more-products/xinchou.png";
import zhaopin from "../../assets/images/common/more-products/zhaopin.png";
import zuzhi from "../../assets/images/common/more-products/zuzhi.png";
import hro from "../../assets/images/common/more-products/hro.png";
import self from "../../assets/images/common/more-products/self.jpg";

const OwlCarousel = Loadable(() => import("react-owl-carousel3"));

const allProducts = [
  { name: "hro", path: "/hro", image: hro },
  { name: "recruitment", path: "/recruitment", image: zhaopin },
  { name: "organization", path: "/organization", image: zuzhi },
  { name: "employee", path: "/employee", image: renshi },
  { name: "attendance", path: "/attendance", image: kaoqin },
  { name: "training", path: "/training", image: peixun },
  { name: "salary", path: "/salary", image: xinchou },
  { name: "performance", path: "/performance", image: jixiao },
  { name: "selfcenter", path: "/selfcenter", image: self },
];

// @param {string[] | string} props.omits

/**
 *
 * @param {object} props
 * @param {string | string[]} props.omits
 * @param {boolean} props.bgLight 
 */
const MoreProducts = props => {
  const { omits, bgLight } = props;

  const options = {
    loop: true,
    nav: true,
    dots: false,
    autoplayHoverPause: true,
    autoplay: false,
    items: 4,
    navText: ["<i class='flaticon-left-1'></i>", "<i class='flaticon-right-1'></i>"],
  };

  let omits2 = omits;
  if (!Array.isArray(omits2)) {
    omits2 = [omits2];
  }

  return (
    <section
      className={cn("process-area pb-70 pt-70", {
        "bg-light": bgLight,
      })}
    >
      <div className="section-title">
        <h2>更多产品</h2>
      </div>
      <OwlCarousel className="more-products owl-carousel owl-theme container" {...options}>
        {allProducts
          .filter(product => !omits2.includes(product.name))
          .map(product => (
            <div className="m-3">
              <Link to={product.path} key={product.name}>
                {/* <div className="col-3"> */}
                <img src={product.image} alt={product.name} className="shadow img-fluid rounded" />
                {/* </div> */}
              </Link>
            </div>
          ))}
      </OwlCarousel>
    </section>
  );
};

export default MoreProducts;
